import * as React from 'react';
import DeleteIcon from '../../asset/icons/Delete.esm.js';
import classNames from 'classnames';
import { CartContext } from '../../context/CartContext.esm.js';
import { CartSettingsContext } from '../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import { lowerCaseFirstLetter, noEndPeriod } from '../../utils/stringFormatting.esm.js';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import '../../constants/api.esm.js';
import { CircleVariant, ColorVariant, SizeVariant, IconStethoscope } from '@invitae/iconograph-react';
import Info from '../Info/Info.esm.js';
import { specimenRequirements } from '../../utils/constants/urls.esm.js';
import { removeSpecialCharactersAndSpaces } from '../../utils/sanitizeText.esm.js';
import { iconReference } from './iconReference.esm.js';
import styles from './OrderCard.module.esm.js';

var Header = function (_a) {
    var _b;
    var _c;
    var handleDeleteOrderGroup = _a.handleDeleteOrderGroup, orderGroup = _a.orderGroup, orderGroupIndex = _a.orderGroupIndex, orderGroupsCount = _a.orderGroupsCount, showCommercialArea = _a.showCommercialArea;
    var meta = React.useContext(CartContext).meta;
    var _d = React.useContext(CartSettingsContext), isCompact = _d.isCompact, isEditable = _d.isEditable;
    var alternateSampleTypes = orderGroup.alternateSampleTypes, _e = orderGroup.commercialArea, commercialArea = _e === void 0 ? '' : _e, productType = orderGroup.productType, rereqSetCode = orderGroup.rereqSetCode, sampleType = orderGroup.sampleType, turnaroundTime = orderGroup.turnaroundTime;
    var sampleTypeLabel = ((_c = meta === null || meta === void 0 ? void 0 : meta.rereq) === null || _c === void 0 ? void 0 : _c.isRerequisition) ? 'New specimen not required' : sampleType;
    var sampleTypeInfo = React.useMemo(function () {
        if (!alternateSampleTypes)
            return null;
        var content = (React.createElement("span", { "data-testid": "specimen-info-tooltip" },
            "Invitae also accepts ",
            lowerCaseFirstLetter(noEndPeriod(alternateSampleTypes)),
            " for this test.",
            ' ',
            React.createElement("a", { href: specimenRequirements, rel: "noopener noreferrer", target: "_blank" }, "Learn more.")));
        return React.createElement(Info, { className: styles.info, content: content });
    }, [alternateSampleTypes]);
    var iconName = showCommercialArea
        ? "headerCommercialArea".concat(removeSpecialCharactersAndSpaces(commercialArea))
        : "headerProductType".concat(productType);
    var Icon = iconReference[iconName] || IconStethoscope;
    return (React.createElement("div", { className: classNames((_b = {},
            _b[styles.headerCompact] = isCompact,
            _b[styles.header] = !isCompact,
            _b)), "data-testid": "order-card-header-".concat(rereqSetCode) },
        React.createElement("div", { className: styles.iconWrapper },
            React.createElement(Icon, { circle: CircleVariant.yes, className: styles.icon, color: ColorVariant.none, currentColor: true, "data-testid": iconName, size: SizeVariant.small }),
            React.createElement("div", { className: styles.headerInfo },
                React.createElement("div", { className: styles.orderTitle }, showCommercialArea ? commercialArea : "Order ".concat(orderGroupIndex + 1, " of ").concat(orderGroupsCount)),
                !isCompact && (React.createElement("div", { className: styles.sampleType },
                    sampleTypeLabel && React.createElement("div", { dangerouslySetInnerHTML: { __html: sampleTypeLabel } }),
                    React.createElement("div", { className: styles.headerInfoSeparator }, "\u2022"),
                    turnaroundTime,
                    sampleTypeInfo)))),
        isEditable && !isCompact && (React.createElement("button", { className: styles.removeOrderButton, "data-testid": "delete-order-group-".concat(productType), onClick: handleDeleteOrderGroup },
            React.createElement(DeleteIcon, null)))));
};

export { Header as default };
//# sourceMappingURL=Header.esm.js.map
